import $ from 'jquery';
import {getConfigValue, requireConfigValues} from '@elements/config-utils';
import initModulesInScope from '@elements/init-modules-in-scope';
import {openOverlay} from './overlay';
import {showNotification, clearAll} from '@elements/alert-notification';
import 'url-search-params-polyfill'; // Edge Polyfill
import 'whatwg-fetch'; // IE10 Polyfill
import fetch from '@elements/fetch';
import formDataEntries from 'form-data-entries';

const configName = '_cartConfig';

let pendingRequest,
    $listLoading,
    $listResult,
    $count;

export function init(){
    $listLoading = $('.js-cart__loading');
    $listResult = $('.js-cart__result-list');
    $count = $('.js-cart__count');

    // initial cart list & cart list count
    if (($listResult && $listResult.length) || ($count && $count.length)) {
        requireConfigValues(['infoUrl'], configName);

        $listLoading.attr('hidden', null);
        $listResult.attr('hidden', 'hidden');

        let request = fetch(getConfigValue('infoUrl', configName), {
            method: 'get',
        });

        showNotification(request);

        request.then(response => response.json())
            .then(result => {
              //  console.log('result', result);
                if (result.success) {
                    setListContent($listResult, $listLoading, result.listContent);

                    if (typeof result.count !== "undefined") {
                        setCount($count, result.count);
                    }
                }
            }).catch(e => {
            console.warn(e);
            $listLoading.attr('hidden', 'hidden');
            $listResult.attr('hidden', 'hidden');
        });
    }
}

export function initInScope($scope, {onAdd, onAddSucceed, onAddFailed} = {}) {
    let pendingRequest = null;
    let $cartForm = $scope.find('.js-cart__form')
    let $cartRemove = $scope.find('.js-cart__remove');
    let $cartLoading = $('.js-cart__loading');
    let $cartResult = $('.js-cart__result');
    let $cartResultList = $('.js-cart__result-list');
    let $cartNotifications = $('.js-cart__notifications');
    let $voucherForm = $scope.find('.js-voucher__form');
    $scope.find('.js-voucher__remove--ajax').on('click', function (e) {
        let $btn = $(this);
        let $voucherRoute = $btn.attr('data-voucher-route');
        let $voucherCode = $btn.attr('data-voucher-code');
        console.log('$voucherCode',  $voucherCode);
        $cartLoading.removeAttr('hidden');
        $cartResult.attr('hidden', 'hidden');

        if (pendingRequest) {
            pendingRequest.abort();
            pendingRequest = null;
        }
        pendingRequest = $.ajax($voucherRoute,{
            type: 'POST',
            dataType: 'json',
            data: { 'voucher': $voucherCode},
        }).done(result => {
            console.log('done', result);
            if (result.success) {
                if (result.content) {
                    $cartResult.empty().append(result.content);
                    $cartLoading.attr('hidden', 'hidden');
                    $cartResult.removeAttr('hidden');
                    initModulesInScope($cartResult);
                }
                setListContent($cartResultList, $cartLoading, result.listContent);
            }
        }).fail(() => {
            console.log('voucher request failed');
        });
    });

    // console.log('$voucherForm',$voucherForm);

    // Voucher submit logic
    if ($voucherForm && $voucherForm.length) {
        $voucherForm.on('submit', function(evt) {
            // console.log('submit');
            evt.preventDefault();
            let $thisForm = $(this);
            let formAction = $thisForm.attr('action');
            let formDataEntriesArr = getFormDataEntries([$thisForm[0]]);
            let params = new URLSearchParams(formDataEntriesArr);

            $cartLoading.removeAttr('hidden');
            $cartResult.attr('hidden', 'hidden');

            if (pendingRequest) {
                pendingRequest.abort();
                pendingRequest = null;
            }

            fetch(formAction, {
                method: 'POST',
                body: params
            })
                .then(response => response.json())
                .then(result => {
                    if (result.success) {
                        if (result.content) {
                            $cartResult.empty().append(result.content);
                            $cartLoading.attr('hidden', 'hidden');
                            $cartResult.removeAttr('hidden');
                            initModulesInScope($cartResult);
                        }
                        setListContent($cartResultList, $cartLoading, result.listContent);
                        if (typeof result.count !== "undefined") {
                            setCount($count, result.count);
                        }
                    } else {
                        if (result.content) {
                            $cartResult.empty().append(result.content);
                        }
                    }
                })
                .catch(error => {
                    $cartLoading.attr('hidden', 'hidden');
                    $cartResult.attr('hidden', 'hidden');
                    console.error(error);
                });
        });
    }
    if ($cartForm && $cartForm.length) {

        let emptyCart = $cartForm.data('empty-cart') || true;
        let openCartOverlay = $cartForm.data('open-cart-overlay');

        requireConfigValues(['cartUrl'], configName);

        $cartForm.each(function () {
            let formTrigger = $(this).data('trigger') || 'submit';

            $(this).on(formTrigger, function (evt) {
                evt.preventDefault();
                let $thisForm = $(this);
                let formAction = $thisForm.attr('action');

                $listLoading.removeAttr('hidden');
                $listResult.attr('hidden', 'hidden');
                $cartLoading.removeAttr('hidden');

                if (emptyCart) {
                    $cartResult.attr('hidden', 'hidden');
                }

                if (openCartOverlay) {
                    openOverlay($(openCartOverlay));
                }
                clearAll({
                    $container: $cartNotifications
                });

                let formDataEntries = getFormDataEntries([$thisForm[0]]);
                let params = new URLSearchParams(formDataEntries);

                let pendingRequest = fetch(formAction, {
                    body: params
                });

                call(onAdd);

                pendingRequest.then((result) => {
                    return result.clone().json()
                }).then((result) => {
                    if (result.success) {
                        let content = result.content || result.html;
                        // console.log('content', content);
                        if (content) {
                            $cartResult.empty().append(result.content);
                            $cartLoading.attr('hidden', 'hidden');
                            $cartResult.removeAttr('hidden');
                            initModulesInScope($cartResult);
                        }

                        setListContent($listResult, $listLoading, result.listContent);

                        if (typeof result.count !== "undefined") {
                            setCount($count, result.count);
                        }

                        let trackingCode = result.trackingCode;
                        if (trackingCode && window['dataLayer']) {
                            dataLayer.push(JSON.parse(trackingCode));
                        }

                        let trackingCodeGa4 = result.trackingCodeGa4;
                        if (trackingCodeGa4 && window['dataLayer']) {
                            dataLayer.push(JSON.parse(trackingCodeGa4));
                        }

                        call(onAddSucceed);
                    } else {
                        let content = result.content || result.html;
                        if (content) {
                            if ($cartResult) {
                                $cartResult.empty().append(result.content);
                                $cartLoading.attr('hidden', 'hidden');
                                $cartResult.removeAttr('hidden');
                                initModulesInScope($cartResult);
                            }
                            if ($cartResultList) {
                                $cartResultList.empty().append(result.listContent);
                                $cartLoading.attr('hidden', 'hidden');
                                $cartResultList.removeAttr('hidden');
                                initModulesInScope($cartResultList);
                            }

                        }


                        call(onAddFailed);
                    }
                }).catch((error) => {
                    if (error.name !== 'AbortError') {
                        /*Do error stuff*/
                        console.error(error);
                    }
                });

                showNotification(pendingRequest, {
                    $container: $cartNotifications
                });

            });

        });

        // remove product from cart
        $cartRemove.on('click', function (evt) {
            evt.preventDefault();
            $(this).closest('form').find('.js-cart__amount').val('0').trigger('change');
        });
    }


    function replaceResult(result){

    }
}


function getFormDataEntries(forms) {
    let formDataArray = [];

    forms.map(form => {
        for(var pair of formDataEntries(form)) {
            formDataArray.push(pair);
        }
    });

    return formDataArray;
}


function setCount($element, count) {
    if (count) {
        $element.attr('hidden', null);
        $element.text(count);
    } else {
        $element.attr('hidden', 'hidden');
    }
}

function setListContent($listResult, $listLoading, content) {
    if (content) {
        $listResult.empty().append(content);
        $listLoading.attr('hidden', 'hidden');
        $listResult.attr('hidden', null);
        initModulesInScope($listResult);
    } else {
        $listLoading.attr('hidden', 'hidden');
        $listResult.attr('hidden', 'hidden');
    }
}

// Call the given function if it really is one
function call(fnc, ...params) {
    if (fnc && typeof fnc === 'function') {
        fnc(...params);
    }
}